import { c as _c } from "react/compiler-runtime";
import Grid, { type GridProps } from '@mui/material/Grid';
import { isSxArray } from 'src/shared/utils/isSxArray';
import { useCompareContext } from '../Context';
import { ComparisonColumn } from './Column';
import { CreditCardCompareColumnContextProvider, MAXIMUM_COLUMNS_DESKTOP, MAXIMUM_COLUMNS_MOBILE } from './ColumnContext';
import { ImpressionWrapper } from './ImpressionWrapper';
import { CreditCardCompareOfferContextProvider } from './OfferContext';
import { ColumnSkeleton } from './Skeleton';
type ComparisonSectionProps = GridProps & {};
const NUMBER_OF_ROWS = 10;
const ComparisonSection = t0 => {
  const $ = _c(12);
  const {
    ...props
  } = t0;
  const {
    isLoading,
    offersToShow,
    stickyHeaderMinHeights
  } = useCompareContext();
  const extendedSx = props.sx && isSxArray(props.sx) ? props.sx : props.sx ? [props.sx] : [];
  const t1 = `-${stickyHeaderMinHeights.mobile}px`;
  const t2 = `-${stickyHeaderMinHeights.desktop}px`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      xs: t1,
      md: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      xs: `repeat(${MAXIMUM_COLUMNS_MOBILE}, minmax(0, 1fr))`,
      md: `repeat(${MAXIMUM_COLUMNS_DESKTOP}, minmax(0, 1fr))`
    };
    t5 = {
      xs: `repeat(${NUMBER_OF_ROWS + 2}, auto)`,
      md: `repeat(${NUMBER_OF_ROWS}, auto)`
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3) {
    t6 = {
      alignSelf: "center",
      mt: t3,
      display: "grid",
      gridTemplateColumns: t4,
      gridTemplateRows: t5,
      gridAutoFlow: "column",
      width: "100%",
      "--lto-highlight-box-desktop": "32px",
      "--lto-highlight-box-mobile": "62px",
      "--lto-highlight-box-spacing": "16px"
    };
    $[5] = t3;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isLoading || $[8] !== offersToShow) {
    let t8;
    if ($[10] !== isLoading) {
      t8 = (offer, index) => <CreditCardCompareColumnContextProvider key={`${offer?.id ?? "none"}-${index}`} value={{
        index
      }}>{!isLoading && offer ? <CreditCardCompareOfferContextProvider offer={offer} index={index}><ImpressionWrapper><ComparisonColumn /></ImpressionWrapper></CreditCardCompareOfferContextProvider> : <ColumnSkeleton />}</CreditCardCompareColumnContextProvider>;
      $[10] = isLoading;
      $[11] = t8;
    } else {
      t8 = $[11];
    }
    t7 = offersToShow.map(t8);
    $[7] = isLoading;
    $[8] = offersToShow;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return <Grid {...props} container={true} sx={[t6, ...extendedSx]}>{t7}</Grid>;
};
export default ComparisonSection;